//todo other action are same with endorsement
import axios from 'axios';
import {
  CREW_RESERVATION,
  GET_CREWENDORSE_RESERVE_LIST,
  GET_RESERVATION_REMARKS,
  GET_ROOM_FOR_BOOKING, REMOVE_RESERVATION,
  RESERVATION_KEY_DETAILS,BEDS_PER_ROOM
} from '../../service/constants.service';
import {GlobalUtility} from '../../service/global-utility.service';

const state = {
  reservation: {},
  reservations: [],
  reservDtls : {},

  roomsAvailable: [],
  roomsOccupied : [],
};

const mutations = {
  set_reservations: (state, params) => {
    state.reservations = params;
  },

  set_reservation : (state,param) =>{
    state.reservation = param;
  },

  set_null_reservation : (state,param) =>{
    state.reservation = {};
  },


  set_null_reservations: (state,param) =>{
    state.reservations = param;
  },


  set_init_reserv_dtls: (state, param) => {
    state.reservDtls = param;
  },


  set_room_available : (state,param) =>{
    state.roomsAvailable = param;
  },

  set_room_occupied : (state,param) =>{
    state.roomsOccupied = param;
  },

  set_null_room_available : (state) =>{
    state.roomsAvailable = [];
  },

  set_null_room_occupued : (state) =>{
    state.roomsOccupied = [];
  },


  set_null_init_book_details : (state,param) =>{
    state.initBookingDetails = {};
  },

};

const actions = {
  async getCrewForReservation({commit}, param) {
    return await axios.post(GET_CREWENDORSE_RESERVE_LIST, param).then((response) => {
      commit('set_reservations', response.data.data);
      commit('set_reservation_pagination',response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Reserve List');
      return false;
    });
  },

  getReservationDetails({commit}, params) {
    return  axios.get(`${CREW_RESERVATION}/${params.id}`).then((response)=>{
      const crewReservation = {
        crew_reservation_id : response.data.crew_reservation_id,
        batch : response.data.batch,
        vessel : response.data.batch.vessel,
        crew : response.data.crew,
        crew_id : response.data.crew_id,
        endorsed_check_in : response.data.endorsed_check_in,
        endorsed_check_out : response.data.endorsed_check_out,
        purposes : response.data.purposes,
        endorsedBy : response.data.endorsedBy,
        endorsedAt : response.data.endorsedAt,
        pcrFile : response.data.pcrFile,
        is_active : response.data.is_active,
      };
      commit('set_reservation',crewReservation);
      commit('set_remarks',response.data.remarks);  //call mutation in remarks.
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get crew endorse details.');
      return false;
    })
  },

  async getCrewReservationRemarks({commit},params){
    return await axios.post(GET_RESERVATION_REMARKS,params).then((response)=>{
      const reservation = {
        crew : response.data.crew,
        id : response.data.crew_reservation_id,
      };
      commit('set_remarks',response.data.remarks);
      commit('set_reservation',reservation);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Reservation Remarks');
      return false;
    });
  },

  reservationKeyDetails({commit},param) {
    return axios.post(RESERVATION_KEY_DETAILS,param).then((response) => {
      commit('set_init_reserv_dtls',response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Init Booking Details.');
      return false;
    });
  },

  async bedsPerRoom({commit},param){
    //GET_ROOM_FOR_BOOKING change to BEDS_PER_ROOM
    return await axios.post(BEDS_PER_ROOM,param).then((response)=>{
      //from room change to beds
      commit('set_room_available',response.data.available_beds);
      commit('set_room_occupied',response.data.occupied_beds);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Room For Booking Details.');
      return false;
    });
  },

  removeReservation({commit},params){
    return axios.post(REMOVE_RESERVATION,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Remove Reservation');
      return false;
    });
  },

  setNullReservation({commit}){
   commit('set_null_reservation');
  },

  setNullReservations({commit}){
    commit('set_null_reservations');
  },

  setNullRoomAvailable({commit}){
    commit('set_null_room_available');
  },

  setNullRoomOccupied({commit}){
    commit('set_null_room_occupued');
  }

};

const getters = {
  reservations: state => (state.reservations),
  reservation : state => (state.reservation),
  reservDtls : state => (state.reservDtls),
  roomsAvailable : state => (state.roomsAvailable),
  roomsOccupied : state => (state.roomsOccupied),
};

export default {state, actions, mutations, getters};
